import { render } from "./DisPlay.vue?vue&type=template&id=ecc08c4c"
import script from "./DisPlay.vue?vue&type=script&lang=js"
export * from "./DisPlay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__